/* eslint-disable @typescript-eslint/no-unused-expressions */
export const modifyHexColor = (hex: string, level: 0 | 1 | 2 | 3 | 4 | 5): string => {
  // 1. Validate and clean hex input
  let cleanHex = hex.replace('#', '');
  if (cleanHex.length === 3) {
    cleanHex = cleanHex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  // 2. Map the 0-5 scale to a percentage (-1 to 1)
  const amountMap = {
    0: -0.3,
    1: -0.2,
    2: -0.1,
    3: 0,
    4: 0.1,
    5: 0.2,
  };

  const amount = amountMap[level] ?? 0;

  // 3. Convert Hex to RGB, adjust, and convert back
  return (
    '#' +
    cleanHex.replace(/../g, (color) => {
      const decimal = parseInt(color, 16);
      const adjusted = Math.round(Math.min(255, Math.max(0, decimal + amount * (amount > 0 ? 255 - decimal : decimal))));
      return adjusted.toString(16).padStart(2, '0');
    })
  );
};

export const isValidHexColor = (hex: string): boolean => {
  const hexRegex = /^#?([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/;
  return hexRegex.test(hex);
};

export const hexToRgb = (hex: string): { r: number; g: number; b: number } | null => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

export const rgbToRgba = (rgb: string, alpha: number): string => {
  const result = rgb.match(/\d+/g);
  if (!result || result.length < 3) {
    throw new Error('Invalid RGB color format');
  }
  const [r, g, b] = result;
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
